export default __webpack_public_path__ + "static/media/ic_reset_password.551ff7cd.svg";